module.exports = __webpack_public_path__ + "img/SomethingRotten21.6098e1c5.png";